import React, { useState } from "react"
import { Button, Modal } from "reactstrap"
import { Edit2 } from "react-feather"
import ModalContent from "./ModalContent"
import { useSelector } from "react-redux"

function EditModal(params) {
	const [isOpen, setIsOpen] = useState(false)
	const dismissModal = () => {
		setIsOpen(false)
	}
	const isDisconnected = useSelector((state) => state.isDisconnected)

	return (
		<>
			<Button.Ripple
				className={"btn-icon rounded-circle"}
				size="sm"
				onClick={() => setIsOpen(true)}
				disabled={isDisconnected}
				color={isDisconnected ? "flat-secondary" : "flat-primary"}
			>
				<Edit2 />
			</Button.Ripple>

			<Modal
				isOpen={isOpen}
				toggle={dismissModal}
				className="modal-dialog-centered"
			>
				<ModalContent {...params} dismissModal={dismissModal} />
			</Modal>
		</>
	)
}

export default EditModal
